
import BookingsAffectedService from "app/services/bookingsAffected/bookingsAffected.service";
import SectionLookupService from "external-services/section-lookup-service/sectionLookup.service";
import LayoutsService from 'external-services/layouts-service/layouts.service';
import AdminService from 'external-services/diary-admin-service/admin.service';
import DateUtilsService from 'external-services/date-utils-service';

/**
 * Has dependency on floorplan-bundle.js
 */

const NS = 'TablePlanCtrl';

export default function TablePlanCtrl(
  $log, $state, $stateParams, $filter, $scope, $mdDialog, $rootScope, $localStorage, $window, Plan, Command, tablesService, pouchService, unregister
) {
  "ngInject";

  const vm = this;
  let deletedTables = [];
  let changedTables = [];
  let bookingConflicts = [];
  // model
  vm.title = 'Table Plan';
  vm.mode = 'layout';
  vm.rendering = false;
  //-- define public methods
  vm.save = save;
  vm.cancel = cancel;
  //-- TablePlan directive
  vm.planConfig = {
    structures: {
      enable: $window.config.plan.structures
    },
    events: {
      enable: $window.config.plan.events
    }
  };
  vm.planAccessor = {
    //directive functions
  };
  vm.planReady = false;

  //-- listeners
  var listeners = [];
  listeners.push($scope.$on('$destroy', () => unregister(listeners)));

  listeners.push($scope.$watch(function () {
    return $scope.vm.planReady;
  }, function (newValue) {
    if (newValue === true) {
      init();
    }
  }));

  //-- methods
  function init() {
    if ($stateParams.id) {
      loadLayout(decodeURIComponent($stateParams.id));
    } else {
      $state.go('settings.layouts');
    }
  }

  function loadLayout(id) {
    vm.rendering = true;
    vm.data = {};
    LayoutsService.getLayoutById(id).then(function (layout) {
      vm.data.layout = layout;
      SectionLookupService.getSectionsByIds([vm.data.layout.sectionId]).then(function (sections) {
        //Update plan title
        vm.title = 'Table Plan';
        if (vm.data.section) {
          vm.title += ' / ' + vm.data.section.name;
        }
        if (vm.data.layout) {
          vm.title += ' (' + vm.data.layout.name + ')';
        }
        //Set data into plan
        vm.data.section = sections[0];
        vm.planAccessor.enablePlan(false);
        vm.planAccessor.setSections([vm.data.section]);
        vm.planAccessor.setLayout(vm.data.layout).then(function () {
          vm.planAccessor.selectLayer(Plan.Layers.Tables);
          vm.planAccessor.enablePlan(true);
          vm.planAccessor.saveState(Command.createPlanLoad());
        });
      });
    }).catch(function (err) {
      $log.error('Failed to load layout', err);
    });
  }

  function cancel() {
    $state.go('settings.floorplan');
  }

  function save(data, evt) {
    vm.data.layout.structures = data.structures;
    //Amend tables missing data
    _.each(data.originalTables, function (table) {
      if (table.sectionId == null) {
        table.sectionId = vm.data.section._id;
      }
      if (table.priority == null) {
        table.priority = 1;
      }
    });
    _.each(data.tables, function (table) {
      if (table.sectionId == null) {
        table.sectionId = vm.data.section._id;
      }
      if (table.priority == null) {
        table.priority = 1;
      }
    });
    //Check for bookings conflicts
    var results = tablesService.getTableChanges(data.tables, data.originalTables);
    if (!results.deletedTables.length && !results.changedTables.length) {
      doSave(data);
    } else {
      const timezoneId = AdminService.getVenueTimezoneId();
      var timeNow = DateUtilsService.getVenueTime(timezoneId);
      // check for conflict
      BookingsAffectedService.checkLayout(results.deletedTables, results.changedTables, timeNow).then(function (bookingConflicts) {
        if (bookingConflicts.length) {
          // show a confirm dialog
          $mdDialog.show({
            controller: 'AffectedBookingsConfirmCtrl',
            controllerAs: 'vm',
            templateUrl: 'app/settings/confirmDialogs/affectedBookingsConfirm.html',
            parent: angular.element(document.body),
            targetEvent: evt,
            locals: {
              bookingConflicts: bookingConflicts
            },
            clickOutsideToClose: true
          })
            .then(function () {
              doSave(data);
            });
        } else {
          // no conflicts found
          doSave(data);
        }
      });
    }
  }

  function doSave(data) {
    //Save layout
    tablesService.updateLayout(new Date(), vm.data.layout, data.tables, data.originalTables).then(function (results) {
      //results
      deletedTables = results.deletedTables;
      changedTables = results.changedTables;
      // check to see if a conflict check is need
      if (!deletedTables.length && !changedTables.length) {
        $state.go('settings.floorplan');
      } else {
        const timezoneId = AdminService.getVenueTimezoneId();
        // check for conflict
        BookingsAffectedService.checkLayout(deletedTables, changedTables, DateUtilsService.getVenueTime(timezoneId)).then(
          function (bookings) {
            bookingConflicts = bookings;
            if (bookingConflicts.length) {
              vm.planAccessor.showConflicts(bookingConflicts);
            } else {
              $state.go('settings.floorplan');
            }
          }
        );
      } //conflicts
      listeners.push($rootScope.$on('booking-edited', reCheckConfict));
    }).catch(function (err) {
      $log.error(err);
      //vm.state = vm.ERROR;
    });
  }

  function reCheckConfict(booking) {
    BookingsAffectedService.checkLayout(deletedTables, changedTables, new Date(), booking).then(function (effectedBookings) {
      if (!effectedBookings || (effectedBookings.length === 0)) {
        // remove the effectted booking from the conflict list
        var bookingIds = bookingConflicts.map(function (bookingItem) {
          return bookingItem._id;
        });
        var index = bookingIds.indexOf(booking._id);
        bookingConflicts.splice(index, 1);
        vm.planAccessor.showConflicts(bookingConflicts);
      }
    });
  }
}
